import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    body {
        line-height: normal;
        transition: none;    
    }

    a {
        outline: none;
    }
`;
